export default __webpack_public_path__ + "static/media/equal-justice-text.e33d0bd9.png";